// sections: main-collection / main-search
var supportPageOffset = window.pageXOffset !== undefined;
var isCSS1Compat = ((document.compatMode || "") === "CSS1Compat");

class LoadProducts extends HTMLElement {
  constructor() {
    super();

    var self = this;
    this.button = this.querySelector('#loadMoreProducts');

    if(this.button.getAttribute('data-scroll') == "button"){
      this.button.addEventListener("click", function(e){
        e.preventDefault();
        e.stopPropagation();
        self.loadProducts();
      });
    } else {
      window.addEventListener('scroll', theme.utils.throttle( self.startLoading.bind(self), 1000));
    }
  }

  startLoading(){
    var y = supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
    if((y + document.documentElement.clientWidth >= theme.utils.offset(this.querySelector('.products_loaded')).top - (document.documentElement.clientWidth / 2)) && this.button.getAttribute('data-over') != "true") {
      this.loadProducts();
    }
  }

  loadProducts(){
    this.productsLoaded = document.querySelectorAll('span.products_loaded_count');
    var self = this, response, content;
    if(this.closest('section')) {
      this.productGrid = this.closest('section').querySelector('#main-collection-product-grid'),
      this.loader = this.querySelector('.loader'),
      this.productsLoadedBarFill = this.querySelector('.prodcuts_loaded_fill');

      this.loader.classList.toggle('hide');
      if(this.button.getAttribute('data-scroll') == "button") this.button.classList.add('hide');

      window.ajaxURL(self.button.getAttribute('href')).then(function (data) {
        response = new DOMParser().parseFromString(data, 'text/html');
        content = response.querySelector("#main-collection-product-grid").innerHTML;

        self.productGrid.innerHTML += content;

        self.productsLoaded.forEach((count) => {
          count.innerHTML = response.querySelector('[data-loaded]').getAttribute('data-loaded');
        });

        self.loader.classList.toggle('hide');

        self.productsLoadedBarFill.style.width = Math.round(response.querySelector('[data-loaded]').getAttribute('data-loaded') * 100 / response.querySelector('[data-products]').getAttribute('data-products')) + '%';

        if(response.querySelector("#loadMoreProducts")){
          self.button.setAttribute('href', response.querySelector("#loadMoreProducts").getAttribute('href'));

          if(self.button.getAttribute('data-scroll') == "button") {
            self.button.classList.remove('hide');
          }
        } else {
          if(self.button.classList.contains('hide')) {
            self.button.classList.add('hide');
          }

          self.button.setAttribute('data-over', true);
        }

        let layout = document.querySelector('collection-layout');

        if(layout && layout.querySelector('button.active')){
          var products = self.productGrid.querySelectorAll('.collection__product');
          var classes = layout.querySelector('button.active').getAttribute('data-layout');
          products.forEach((product) => {
            product.className = 'flex__item collection__product aos-init aos-animate ' + classes;
          });
        }

        yotpoWidgetsContainer.initWidgets(false);
      });
    }
  }
}
customElements.define('load-products', LoadProducts);